/**
 * Automy.Core.Enums.Reporting.Identity.ReportProvider
 * JSON `provider` (string token). Native = 1, PowerBI = 2. Never send 0.
 * Existing rows without a value are Power BI. Tableau is not a provider.
 */
export default Object.freeze({
  Native: 'native',
  PowerBI: 'power-bi',
});
